import {registerComponent} from '@helpers/vue'

import router from './router'
import FieldRecordSystemModuleRoot from './FieldRecordSystemModuleRoot'

registerComponent(FieldRecordSystemModuleRoot, 'frs', {router})
